import axios from 'axios';

const api = axios.create({
  baseURL: 'https://delicate-rain-a888.dunkenvizlo.workers.dev',
  withCredentials: true
});

// 📰 News Routes
export const getNews = () => api.get('/news');
export const getNewsById = (id) => api.get(`/news/${id}`);
export const createNews = (data) => api.post('/news', data);
export const updateNews = (id, data) => api.put(`/news/${id}`, data);
export const deleteNews = (id) => api.delete(`/news/${id}`);



export default api;

